var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubCatUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#2B2726"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12190_55515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 16.6667C16.3669 16.6667 16.6654 16.3682 16.6654 16C16.6654 15.6319 16.3669 15.3334 15.9987 15.3334C15.6305 15.3334 15.332 15.6319 15.332 16C15.332 16.3682 15.6305 16.6667 15.9987 16.6667Z",
    fill: "#403A37",
    stroke: "#393332",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 22.6667C19.6806 22.6667 22.6654 19.6819 22.6654 16C22.6654 12.3181 19.6806 9.33337 15.9987 9.33337C12.3168 9.33337 9.33203 12.3181 9.33203 16C9.33203 19.6819 12.3168 22.6667 15.9987 22.6667Z",
    stroke: "#403A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12190_55515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubCatUnselected);
export default __webpack_public_path__ + "static/media/sub-cat-unselected.0e469dd889a4e274cadf9de051da7c77.svg";
export { ForwardRef as ReactComponent };